<script setup lang="ts">
import { RouteNames } from "@/router";
</script>

<template>
  <div class="try-skore-button">
    <RouterLink :to="{ name: RouteNames.Dispatch }" class="button">
      <i class="icon icon-diamond left" />
      <span class="text-base-medium">Try for free</span>
    </RouterLink>
  </div>
</template>

<style scoped>
@property --gradient-angle {
  inherits: false;
  initial-value: 90deg;
  syntax: "<angle>";
}

@keyframes gradient-rotate {
  from {
    --gradient-angle: 0deg;
  }

  to {
    --gradient-angle: 360deg;
  }
}

.try-skore-button {
  --height: var(--numbers-36);
  --gradient-angle: 90deg;
  --gradient: linear-gradient(var(--gradient-angle), #e2ae81 0%, #e08c97 37%, #be91cd 100%);

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &::before {
    position: absolute;
    z-index: 1;
    border-radius: var(--numbers-8);
    background: var(--gradient);
    content: "";
    filter: blur(var(--numbers-4));
    inset: 0;
    transition: filter var(--animation-duration) var(--animation-easing);
  }

  &::after {
    position: absolute;
    z-index: 2;
    border-radius: var(--numbers-10);
    margin: -2px;
    background: var(--gradient);
    content: "";
    inset: 0;
  }

  &:hover {
    animation: gradient-rotate 3s linear infinite;

    &::before {
      filter: blur(var(--numbers-6));
    }
  }

  .button {
    position: relative;
    z-index: 3;
    display: inline-flex;
    min-width: var(--height);
    height: var(--height);
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: var(--numbers-16);
    border: 0;
    border-radius: var(--numbers-8);
    background-color: var(--background-primary);
    color: var(--content-primary);
    gap: var(--numbers-8);
    text-decoration: none;

    .icon {
      background: var(--gradient);
      background-clip: text;
      font-size: 1.1em;
      -webkit-text-fill-color: transparent;
      vertical-align: middle;
    }
  }
}
</style>
